<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.construction.painting.title')" header-tag="h3" class="bg-default-card">
                    <b-tabs>
                        <b-tab :title="$t('general.construction.painting.current_painting.title')" @click="refreshCurrent" class="removeFocus">
                            <painting-current 
                                ref="paintingCurrent"
                                :currentDisciplines="getData.currentDisciplines"
                                :rowChangeSelectOptions="getData.rowChangeSelectOptions"
                            >
                            </painting-current>
                        </b-tab>

                        <b-tab :title="$t('general.construction.painting.archived_painting.title')" @click="refreshArchived" class="removeFocus">
                            <painting-archived 
                                ref="paintingArchived"
                                :currentDisciplines="getData.currentDisciplines"
                                :rowChangeSelectOptions="getData.rowChangeSelectOptions"
                            >
                            </painting-archived>
                        </b-tab>

                        <b-tab :title="$t('general.construction.painting.painting_pdfs.title')" @click="paintingPdfsTable" class="removeFocus">
                            <painting-pdfs-table 
                                ref="paintingPDFs"
                            >
                            </painting-pdfs-table >
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import paintingCurrent from '@/components/pages/project/construction/painting/painting_current.vue';
import paintingArchived from '@/components/pages/project/construction/painting/painting_archived.vue';
import paintingPdfsTable from '@/components/pages/project/construction/painting/painting_pdfs_table.vue';

export default {
    name: 'painting',
    components: {
        paintingCurrent,
        paintingArchived,
        paintingPdfsTable,
    },
    data () {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.painting.title'),
                    active: true
                }
            ],
            currentTab: 0,
            getData: {
                currentDisciplines: [],
                rowChangeSelectOptions: {
                    work_type_id: [],
                    painting_system_id: [],
                    ral_id: [],
                },
            },
        }
    },
    mounted () {
        this.getDisciplineSelect();
        this.getWorkTypeSelect();
        this.getPaintingSystemSelect();
        this.getRALSelect();
    },
    methods: {
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        refreshCurrent () {
            if (this.currentTab != 0) {
                this.$refs.paintingCurrent.onLoadTable();
            }

            this.currentTab = 0;
        },
        refreshArchived () {
            if (this.currentTab != 1) {
                this.$refs.paintingArchived.onLoadTable();
            }

            this.currentTab = 1;
        },
        paintingPdfsTable () {
            if (this.currentTab != 2) {
                this.$refs.paintingPDFs.onLoadTable();
            }

            this.currentTab = 2;
        },
        getDisciplineSelect () {
            http.route('discipline?project_id=' + this.$route.params.id + '&ids[]=1&ids[]=2&ids[]=3').get()
            .then(response => {
                if (!response.isError) {
                    this.getData.currentDisciplines = response.data; 
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        getWorkTypeSelect () {
            http.route('projectsetting?project_id=' + this.$route.params.id + '&get_all=1&filters[type]=work_type').get()
            .then(response => {
                if (!response.isError) {
                    var work_types = [];
                    response.data.forEach((field, index) => {
                        work_types[index] = {
                            id: field.id,
                            name: field.value,
                        };
                    });
                    this.getData.rowChangeSelectOptions['work_type_id'] = work_types; 
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        getPaintingSystemSelect () {
            http.route('projectsetting?project_id=' + this.$route.params.id + '&get_all=1&filters[type]=painting_system').get()
            .then(response => {
                if (!response.isError) {
                    var painting_systems = [];
                    response.data.forEach((field, index) => {
                        painting_systems[index] = {
                            id: field.id,
                            name: field.value,
                        };
                    });
                    this.getData.rowChangeSelectOptions['painting_system_id'] = painting_systems; 
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        getRALSelect () {
            http.route('projectsetting?project_id=' + this.$route.params.id + '&get_all=1&filters[type]=ral').get()
            .then(response => {
                if (!response.isError) {
                    var rals = [];
                    response.data.forEach((field, index) => {
                        rals[index] = {
                            id: field.id,
                            name: field.value,
                        };
                    });
                    this.getData.rowChangeSelectOptions['ral_id'] = rals; 
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/construction/painting/painting.vue